import React, { useEffect } from 'react';
import { Grid } from '@mui/material'
import UploadFile from './uploadFile/UploadFile';
import FilterBar from './filterBar';
import FilesTable from './filesTable/filesTable';
import { useDispatch, useSelector } from 'react-redux';
import { getFiles } from '../../../redux/thunks/filesUploadThunk';
import SearchUsingFilter from './searchUsingFilter/index'

const FileUpload = () => {
    const dispatch = useDispatch();
    const { company } = useSelector(state => state.company)
    useEffect(() => {
        if (company.id) {
            dispatch(getFiles({ companyId: company.id }));
        }
    }, [company.id])
    return (
        <>
            <FilterBar />
            <Grid container>
                <Grid item xs={12}>
                    <UploadFile />
                </Grid>
                <Grid item xs={12}>
                    <SearchUsingFilter />
                </Grid>
                <Grid item xs={12} className='mt-5'>
                    <FilesTable />
                </Grid>
            </Grid>
        </>
    )
}

export default FileUpload
